// extracted by mini-css-extract-plugin
export default {"name":"navbar_name__OEgK0","nav-menu":"navbar_nav-menu__49e30"};